export default __webpack_public_path__ + "static/media/homeSection1.37736c0d.jpg";